import React, { Component, Fragment } from "react";
import api from "../../../../../services/api";
import { Link } from "react-router-dom";
import NomeUnidade from "../../../../UI/NomeUnidade";

export default class FormMeta extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            aplicationName: "Form Meta",
            cr: "",
            linhas: [
                "Consultoria em Tecnologia",
                "Serviços Técnicos Especializados",
                "Pesquisa, Desenvolvimento e Inovação",
                "Metrologia",
                "Serviços Complementares",
            ],
            servicos: [
                {
                    linhaAtuacao: "Consultoria em Tecnologia",
                    categoria: "Consultoria em Processos Produtivos",
                    cr: "3.02.01.02.02"
                },
                {
                    linhaAtuacao: "Consultoria em Tecnologia",
                    categoria: "Consultoria para Atendimento de Legislações, Normas e Regulamentos Técnicos",
                    cr: "3.02.01.02.04" 
                },
                {
                    linhaAtuacao: "Serviços Técnicos Especializados",
                    categoria: "Serviços Operacionais",
                    cr: "3.02.01.01.02" 
                },
                {
                    linhaAtuacao: "Pesquisa, Desenvolvimento e Inovação",
                    categoria: "Pesquisa, Desenvolvimento e Inovação de Processos",
                    cr: "3.02.02.01.02" 
                },
                {
                    linhaAtuacao: "Pesquisa, Desenvolvimento e Inovação",
                    categoria: "Pesquisa, Desenvolvimento e Inovação de Produto",
                    cr: "3.02.02.01.01" 
                },
                {
                    linhaAtuacao: "Metrologia",
                    categoria: "Calibração",
                    cr: "3.02.01.05.02" 
                },
                {
                    linhaAtuacao: "Metrologia",
                    categoria: "Ensaios",
                    cr: "3.02.01.05.01" 
                },
                {
                    linhaAtuacao: "Serviços Complementares",
                    categoria: "Consultoria em Gestão Empresarial",
                    cr: "3.02.01.02.02" 
                },
            ],
        }

    }

    onSubmit = async (event) => {
        event.preventDefault();

        try {

            let { linhaAtuacao, categoria, cr, produtoNacional, descritivoProduto, unidade } = event.target;
            let cadastro = {
                Sigla: unidade.value,
                Produto: produtoNacional.value, 
                DescritivoProduto: descritivoProduto.value,
                Objetivo: null,
                ConteudoProgramatico: null,
                ResultadosEsperados: null,
                Beneficios: null,
                ContaContabilId: null,
                Nome: null,
                Codigo: cr.value.replaceAll(".", ""),
                CodigoMascara: cr.value,
                NomeNivel4: null,
                NomeNivel5: categoria.value
            }


            /**/
            let status = await api.post("/sti/novosprodutos", cadastro)
            if(status.data.status === "ok") {
                window.showNotification('Cadastrado com sucesso', 'success');
                event.target.reset();
            }
            else window.showNotification(status.data.status || 'Erro ao cadastrar', 'danger');
            

        } catch (erro) {
            alert("Erro ao cadastrar", erro);
        }
    }

    onChangeLinha = (event) => {
        let { value } = event.target;
        let categorias = this.state.servicos.filter(categoria => categoria.linhaAtuacao === value);
        this.setState({ categorias: categorias });
    }

    onChangeCategoria = (event) => {
        let selecionado = this.state.servicos.filter(selecionado => selecionado.categoria === event.target.value);
        this.setState({ cr: selecionado[0].cr });
    }

    render() {
        let { linhas, categorias, cr } = this.state
        return (
            <Fragment>
                <div className="content">
                    <div className="row">
                        <div className="col-md-8 ml-auto mr-auto">
                            <div className="card card-user">
                                <div className="card-header">
                                    <h5 className="card-title">Cadastrar novo produto</h5>
                                    <Link to={location => ({ ...location, pathname: (this.props.location && this.props.location.anterior) || "/sti" })}>
                                        <button className="btn" style={{float: "right"}}>Voltar</button>
                                    </Link>
                                </div>
                                <div className="card-body">
                                    <form onSubmit={this.onSubmit} className="gap" id="cadastrocurso">

                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="linhaAtuacao">Linha de Atuação:</label>
                                                    <select name="linhaAtuacao" id="linhaAtuacao" onChange={this.onChangeLinha} className="form-control" required>
                                                        <option hidden>Escolha uma Linha de Atuação</option>
                                                        {linhas.map((linha) => <option key={linha} value={linha}>{linha}</option>)}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div className="row">
                                            <div className="col-md-8">
                                                <div className="form-group">
                                                    <label htmlFor="categoria">Categorias:</label>
                                                    <select name="categoria" onChange={this.onChangeCategoria} className="form-control" required>
                                                        <option hidden>Escolha uma Categoria</option>
                                                        {categorias && categorias.map((categoria) => <option key={categoria.categoria} value={categoria.categoria}>{categoria.categoria}</option>)}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="cr">CR</label>
                                                    <input type="text" className="form-control" placeholder="cr" id="cr" name="cr" defaultValue={cr} disabled />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="produtoNacional">Produto</label>
                                                    <input type="text" className="form-control" placeholder="Produto" id="produtoNacional" name="produtoNacional" required />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="descritivoProduto">Descrição</label>
                                                    <input type="text" className="form-control" placeholder="Descrição" id="descritivoProduto" name="descritivoProduto" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="unidade">Unidade</label>
                                                    <input type="text" className="form-control" placeholder="Unidade" id="unidade" name="unidade" required disabled defaultValue={this.props.match.params.unidade.toUpperCase()} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="update ml-auto mr-auto">
                                                <button type="submit" className="btn btn-primary btn-round">Cadastrar</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }


}